import React from "react";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {useHistory} from 'react-router-dom'
const Header = (props) =>{
    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
        <div>
            <div id="frist_header" className="f-f-r">
                NATIONWIDE SHIPPING ON ALL ORDERS
            </div>
            <nav id="header_nav">
                <div className="row col-12">
                    <div className="col" id="nav_div_frist">
                        <p id="logo_word_header"
                            onClick={(()=>{
                                history.push('/')
                            }
                                )}
                        >Smart Shopper.</p>
                    </div>
                    <div className="col-sm-6 mag-A" id="nav_div_middle">
                        <ul id="ul_line">
                            {
                                props.whihOne === "home" ?
                                <li id="active">Home</li>:
                                <li
                                onClick={(()=>{
                                    history.push('/')
                                }
                                    )}
                                >Home</li>
                            }
                            {
                                props.whihOne === "ourstory" ?
                                <li id="active">Our Story</li>:
                                <li
                               onClick={(()=>{
                                   history.push('/our/story')
                               })} 
                                >Our Story</li>
                            }
                            {
                                props.whihOne === "shop" ?
                                <li id="active">Shop</li>:
                                <li
                               onClick={(()=>{
                                   history.push('/shop')
                               })} 
                                >Shop</li>
                            }
                            {
                                props.whihOne === "specialoffers" ?
                                <li id="active">Special Offers</li>:
                                <li
                                onClick={(()=>{
                                    history.push('/specail/offers')
                                })} 
                                >Special Offers</li>
                            }
                            {
                                props.whihOne === "contact" ?
                                <li id="active">Contact</li>:
                                <li
                                onClick={(()=>{
                                    history.push('/contact')
                                })} 
                                >Contact</li>
                            }
                            {/* <li>
                                <button id="header_domate_button"
                                onClick={(()=>{
                                    history.push('/donate')
                                })} 
                                >Donate</button>
                            </li> */}
                            
                        </ul>
                    </div>
                    <div className="col mag-A" id="nav_div_last">
                        <ul id="ul_line" className="icon_header">
                            {
                                props.whihOne === "profile" ?
                                <li><AccountCircleOutlinedIcon id="active"/></li>:
                                <li
                               onClick={(()=>{
                                    history.push('/login')
                               })} 
                                ><AccountCircleOutlinedIcon/></li>

                            }
                            {
                                props.whihOne === "seacher"?
                                <li><SearchOutlinedIcon id="active" /></li>:
                                <li><SearchOutlinedIcon 
                                onClick={(()=>{
                                    history.push('/seacher')
                                })} 
                                /></li>
                            }
                            
                            {
                                props.whihOne === "wishlist" ?
                                <li><FavoriteBorderOutlinedIcon id="active"/></li>:
                                <li
                               onClick={(()=>{
                                   history.push('/wishlist')
                               })} 
                                ><FavoriteBorderOutlinedIcon/></li>

                            }
                            {
                                props.whihOne === "cart" ?
                                <li><ShoppingCartOutlinedIcon id="active"/></li>:
                                <li
                               onClick={(()=>{
                                   history.push('/cart')
                               })} 
                                ><ShoppingCartOutlinedIcon/></li>

                            }
                        </ul>
                        <MenuOutlinedIcon id="menu_header"
                        aria-controls={open ? 'demo-positioned-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        />
                         <Menu
                        id="demo-positioned-menu"
                        aria-labelledby="demo-positioned-button"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                        }}
                        transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                        }}
                    >
                        <MenuItem 
                       onClick={(()=>{
                        history.push('/');
                        handleClose()
                        }
                        )}
                        >Home</MenuItem>

                        <MenuItem 
                        onClick={(()=>{
                        history.push('/our/story');
                        handleClose()
                        }
                        )}
                        >Our Story</MenuItem>

                        <MenuItem 
                        onClick={(()=>{
                        history.push('/shop');
                        handleClose()
                        }
                        )}
                        >Shop</MenuItem>


                        <MenuItem 
                        onClick={(()=>{
                        history.push('/specail/offers');
                        handleClose()
                        }
                        )}
                        >Special Offers</MenuItem>

                        <MenuItem 
                        onClick={(()=>{
                        history.push('/contact');
                        handleClose()
                        }
                        )}
                        >Contact</MenuItem>
                         <MenuItem 
                        onClick={(()=>{
                        history.push('/seacher');
                        handleClose()
                        }
                        )}
                        >Seacher</MenuItem>
                        <MenuItem 
                        onClick={(()=>{
                        history.push('/login');
                        handleClose()
                        }
                        )}
                        >Profile</MenuItem>

                        <MenuItem 
                        onClick={(()=>{
                        history.push('/wishlist');
                        handleClose()
                        }
                        )}
                        >Wishlist</MenuItem>

                        <MenuItem 
                        onClick={(()=>{
                        history.push('/cart');
                        handleClose()
                        }
                        )}
                        >Cart</MenuItem>
                        {/* <MenuItem>
                        <button id="header_domate_button"
                            className="padding_down_1px"
                                 onClick={(()=>{
                                    history.push('/donate');
                                    handleClose()
                                    }
                                    )}
                                >Donate</button>
                        </MenuItem> */}
                        
                    
                        
            
                    </Menu>
                    </div>
                </div>
            </nav>
        </div>
    )
}
export default Header;